<template>
  <b-dropdown :text="label.toString()">
    <b-dropdown-item v-for="(item, key) in items" @click="onClick(item)" :key="`${getReadableName(item)}-${key}`">{{
      getReadableName(item)
    }}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
export default {
  props: {
    label: [Number, String],
    onChanged: Function,
    items: Array
  },
  methods: {
    onClick: function(value) {
      this.$emit('onChanged', value)
    },
    getReadableName: function(item) {
      if (item.name) {
        return item.name
      } else {
        if (item.name === '') {
          return '-Üres-'
        }
        return item
      }
    }
  }
}
</script>
<style></style>
